module.exports = __webpack_public_path__ + "assets/img/module_card__no_lecturer.svg";